import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import Landing from "@/pages/Landing";
import Competitions from "@/pages/Competitions";
import CompetitionChoice from "@/pages/CompetitionChoice";
import UploadForm from "@/pages/UploadForm";
import Support from "@/pages/Support";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import DJDashboard from "@/pages/DJDashboard";
import FileBrowser from "@/pages/FileBrowser";

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/competizioni" element={<Competitions />} />
          <Route path="/competizioni/:id" element={<CompetitionChoice />} />
          <Route path="/competizioni/:id/:kind" element={<UploadForm />} />
          <Route path="/assistenza" element={<Support />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/dj" element={<DJDashboard />} />
          <Route path="/admin/competizioni/:id/files" element={<FileBrowser />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
